import { render, staticRenderFns } from "./DemoBanner.vue?vue&type=template&id=26aa3af4&scoped=true&"
import script from "./DemoBanner.vue?vue&type=script&lang=js&"
export * from "./DemoBanner.vue?vue&type=script&lang=js&"
import style0 from "./DemoBanner.vue?vue&type=style&index=0&id=26aa3af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aa3af4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
